<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="w-full flex py-5 px-5">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditor's Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                  id="accreditorName"
                  v-model="formValues.accreditorName"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="accreditorName"
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-2 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditor's Ownership</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.accredatorOwnershipId"
                  :clearable="clearable"
                  :elevation="1"
                  :items="ACCREDATOR_OWNERSHIP"
                  :loading="accOwnerLoading"
                  :searchable="searchable"
                  dense
                  item-text="name"
                  item-value="id"
                  label="accreditor's ownership"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>

          <div class="w-full md:w-1/2 px-3 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Region</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.region_id"
                  :clearable="clearable"
                  :elevation="1"
                  :items="REGIONS"
                  :loading="regionLoading"
                  :searchable="searchable"
                  dense
                  item-text="name"
                  item-value="id"
                  label="regions"
                  solo
                  @change="regionOnChange($event)"
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 md:mb-0  ">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Zone</label
            >

            <v-select
                v-model="formValues.zone_id"
                :clearable="clearable"
                :elevation="1"
                :items="FILTERED_ZONES"
                :loading="zoneLoading"
                :searchable="searchable"
                dense
                item-text="name"
                item-value="id"
                label="zones"
                solo
                @change="zoneOnChange($event)"
            ></v-select>

            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 md:mb-0">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Woreda</label
            >

            <v-select
                v-model="formValues.woreda_id"
                :clearable="clearable"
                :elevation="1"
                :items="FILTERED_WOREDAS"
                :loading="woredaLoading"
                :searchable="searchable"
                dense
                item-text="name"
                item-value="id"
                label="woredas"
                solo
            ></v-select>

            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Latitude</label
            >
            <!-- <validation-provider rules="required" v-slot="{ errors }"> -->
            <input
                id="latitude"
                v-model="formValues.latitude"
                class="
                shadow
                appearance-none
                border
                rounded
                w-full
                py-2
                px-3
                text-gray-700
                leading-tight
                focus:outline-none focus:shadow-outline
              "
                name
                placeholder="eg-7.00000"
                type="number"
            />
            <!-- <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider> -->
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-64 md:mb-0">
            <label
                class="
              block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Longtiude</label
            >
            <!-- <validation-provider rules="required" v-slot="{ errors }"> -->
            <input
                id="longtiude"
                v-model="formValues.longtiude"
                class="
              shadow
                appearance-none
                border
                rounded
                w-full
                py-2
                px-3
                text-gray-700
                leading-tight
                focus:outline-none focus:shadow-outline
              "
                name
                placeholder="eg-8.00000"
                type="number"
            />
            <!-- <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider> -->
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditor's Director Name</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="accreditorDirectorName"
                  v-model="formValues.accreditorDirectorName"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="accreditorDirectorName"
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditor's Director Email Address</label
            >
            <validation-provider v-slot="{ errors }" rules="required|email">
              <input
                  id="accreditorDirectorEmail"
                  v-model="formValues.accreditorDirectorEmail"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="accreditorDirectorEmail"
                  type="email"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditor's Director Phone Number</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                phone_regex: '^([+]2519|2519|09|9)\\d{8}|^(0|[+]251|251)\\d{9}',
              }"
            >
              <input
                  id="accreditorDirectorPhone"
                  v-model="formValues.accreditorDirectorPhone"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="accreditorDirectorPhone"
                  type="number"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Institutional Email</label
            >
            <validation-provider v-slot="{ errors }" rules="required|email">
              <input
                  id="institutionalEmail"
                  v-model="formValues.institutionalEmail"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="institutionalEmail"
                  type="email"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Institutional Phone Number</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                phone_regex: '^([+]2519|2519|09|9)\\d{8}|^(0|[+]251|251)\\d{9}',
              }"
            >
              <input
                  id="institutionalPhone"
                  v-model="formValues.institutionalPhone"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="institutionalPhone"
                  type="number"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditation Date:
            </label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-menu
                  ref="menu"
                  v-model="startMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formValues.accreditationDate"
                      label="accreditation date"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    ref="accreditationDate"
                    v-model="formValues.accreditationDate"
                    :max="date"
                    no-title
                    scrollable
                    @input="startMenu = false"
                ></v-date-picker>
              </v-menu>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditation Code</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="accreditationCode"
                  v-model="formValues.accreditationCode"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="accreditationCode"
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accredator's Status</label
            >
            <validation-provider v-slot="{ errors }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-switch
                      v-model="formValues.isActive"
                      color="green"
                      hide-details
                      v-on="on"
                  ></v-switch>
                </template>
                <span>{{
                    formValues.isActive == true ? "Active" : "Not Active"
                  }}</span>
              </v-tooltip>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
        </div>
        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full">
            <button
                class="
                float-right
                shadow
                bg-teal-600
                hover:bg-teal-600
                focus:shadow-outline focus:outline-none
                text-white
                font-bold
                py-2
                px-4
                rounded
              "
                type="button"
                @click="showConfirmation(formValues.editMode)"
            >
              {{ formValues.editMode ? "Update Accreditor" : "Add Accreditor" }}
            </button>
          </div>
          <div class="md:w-2/3"></div>
        </div>
      </v-card>
      <confirmationModal
          v-if="confirmation"
          @confirmed="submit"
          :title="title"
          @close="confirmation = false"
          @openDialog="true"
      >
      </confirmationModal>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {email, regex, required} from "vee-validate/dist/rules";
import {getAccredatorOwnership, getRegionList, getWoredaByZoneId, getZoneByRegionId,} from "@/utils/helper";
import ethiopic from "ethiopic-calendar";
import confirmationModal from "../../common/confirmation-modal.vue";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("phone_regex", {
  ...regex,
  message: "Invalid phone number",
});
extend("regex", {
  ...regex,
  message: "Name should contain only letters",
});
extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  props: {
    accreditor: Object,
  },
  components: {
    confirmationModal,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        accreditorName: "",
        accreditorGeolocation: "",
        accredatorOwnershipId: "",
        accreditorDirectorName: "",
        accreditorDirectorEmail: "",
        accreditorDirectorPhone: "",
        institutionalEmail: "",
        accreditationDate: "",
        institutionalPhone: "",
        accreditationCode: "",
        longtiude: "",
        latitude: "",
        woreda_id: null,
        zone_id: null,
        region_id: null,
        isActive: true,
        editMode: false,
      },
      startMenu: false,
      ACCREDATOR_OWNERSHIP: [],
      date: new Date().toISOString().substr(0, 10),
      etDate: null,
      clearable: true,
      searchable: true,
      accOwnerLoading: false,
      REGIONS: [],
      FILTERED_ZONES: [],
      FILTERED_WOREDAS: [],
      regionLoading: false,
      zoneLoading: false,
      woredaLoading: false,

      confirmation: false,
      title:''
    };
  },
  async beforeMount() {
    this.accOwnerLoading = true;
    const res = await getAccredatorOwnership();
    const filteredData = res.filter(item => item.name !== "Private");
    this.ACCREDATOR_OWNERSHIP = filteredData;
    this.accOwnerLoading = false;
    this.regionLoading = true;
    this.REGIONS = await getRegionList();
    this.regionLoading = false;
  },
  async created() {
    const date = new Date().toISOString().substr(0, 10);
    this.etDate = this.convertGE(date);
    if (this.accreditor != null) {
      this.formValues = this.accreditor;
      this.formValues.editMode = true;

      this.formValues.region_id
          ? this.regionOnChange(this.formValues.region_id)
          : "";
      this.formValues.zone_id ? this.zoneOnChange(this.formValues.zone_id) : "";
    }
  },
  methods: {
    async showConfirmation(editMode) {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();

      this.confirmation = true;
      this.title = editMode? "Update Accreditor" : "Add Accreditor";
    },
    async regionOnChange(event) {
      this.zoneLoading = true;
      this.FILTERED_ZONES = [];
      this.FILTERED_WOREDAS = [];
      const regionId = event;
      event ? (this.FILTERED_ZONES = await getZoneByRegionId(regionId)) : null;
      this.zoneLoading = false;
    },
    async zoneOnChange(event) {
      this.woredaLoading = true;
      const zoneId = event;
      event ? (this.FILTERED_WOREDAS = await getWoredaByZoneId(zoneId)) : null;
      this.woredaLoading = false;
    },
    convertGE(val) {
      if (!val) return val;
      const [year, month, day] = val.split("-").map(Number);
      if (this.pickerType === "year") {
        let etDate = ethiopic.ge(year, month || 6, day || 1); // so it will be the same year in both directions
        return etDate.year.toString().padStart(4, "0");
      } else {
        let etDate = ethiopic.ge(year, month || 1, day || 1);
        return (
            etDate.year.toString().padStart(4, "0") +
            "-" +
            etDate.month.toString().padStart(2, "0") +
            "-" +
            etDate.day.toString().padStart(2, "0")
        );
      }
    },
    async submit() {
      this.$emit("registerOrUpdateAccreditor", this.formValues);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>
